import {postSync} from "./http";

export function isString(str){
    return (typeof str=='string')&&str.constructor==String;
}

export function isEmpty(checkValue) {
    if (checkValue === undefined) {
        return true;
    }
    if (checkValue === 'undefined') {
        return true;
    }
    if (checkValue === null) {
        return true;
    }
    if (checkValue === 'null') {
        return true;
    }
    if (checkValue === "") {
        return true;
    }
    if (checkValue === "NaN") {
        return true;
    }
    return false;
}
export async function getDateFormatObject() {
    let dateFormat='';
    await postSync('aisino/df/getDataFormat').then(response=>{
        dateFormat=response
    });
    return dateFormat;
}

export function pwdCheck(value){
    let regex1 =/^(?=.*[a-z]).{6,20}$/;
    let regex2 =/^(?=.*[A-Z]).{6,20}$/;
    let regex3 =/^(?=.*\d).{6,20}$/;
    let regex4 =/^(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{6,20}$/;
    const pattern = /^[^/\\'"{}[\],:;：；【】、“]+$/;
    if(!isEmpty(value)&&!pattern.test(value)){
        return 1;
    }
    let matchTimes = 0;
    if(regex1.test(value)){
        matchTimes++;
    }
    if(regex2.test(value)){
        matchTimes++;
    }
    if(regex3.test(value)){
        matchTimes++;
    }
    if(regex4.test(value)){
        matchTimes++;
    }
    if(matchTimes>2){
        return 2;
    }
    else{
        return 3;
    }
}
export function checkContactNum(value){
    let regex =  /^(?:\+\d{7,}|\d{8,})$/;
    if(regex.test(value)){
        return true;
    }
    else{
        return false;
    }
}

//判断字符串是否包含某个子串，忽略大小写
export function containsIgnoreCase(fullStr,subStr) {
    return fullStr.toLowerCase().includes(subStr.toLowerCase());
}

//判断字符串数组是否包含某个字符串，忽略大小写
export function arrayContainsIgnoreCase(strArray, itemStr) {
    if(strArray && strArray instanceof Array){
        return strArray.some(item => item.toLowerCase() === itemStr.toLowerCase());
    }
    return false;
}